import { render, staticRenderFns } from "./RPopupEdit.vue?vue&type=template&id=48b7ebd1&"
import script from "./RPopupEdit.vue?vue&type=script&lang=js&"
export * from "./RPopupEdit.vue?vue&type=script&lang=js&"
import style0 from "./RPopupEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports